'use client';

export function CheckBox({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onChange}
      className={`relative flex size-6 shrink-0 items-center justify-center rounded-[5px] border transition-colors ${
        checked ? 'border-[#4b0fea] bg-[#4b0fea]' : 'border-[#d4d4d4] bg-white'
      }`}
      aria-checked={checked}
      role="checkbox"
    >
      {checked && (
        <svg
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
          className="text-white"
        >
          <path
            d="M1 5L5 9L13 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}

export function RadioButton({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onChange}
      className={`relative flex size-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
        checked ? 'border-[#4b0fea]' : 'border-[#aaa]'
      }`}
      aria-checked={checked}
      role="radio"
    >
      {checked && <div className="size-3 rounded-full bg-[#4b0fea]" />}
    </button>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="shrink-0 text-black/60"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}
